/**
 * Per-query React Query staleTime overrides.
 *
 * The global default in App.tsx is 30s — appropriate for live data (active
 * sessions, free spots, spot details). For data that changes far less often,
 * the 30s default causes pointless refetches.
 *
 * Two tiers cover everything we care about:
 *
 *   STATIC — config-like data that essentially never changes during a user
 *   session (building levels, invite codes). 10 minutes.
 *
 *   SLOW — data that changes infrequently and not in real-time (user's own
 *   profile, disabled spots, schedules the user is editing). 5 minutes.
 *
 * Real-time data (spots/mine, sessions/active, spots/free) keeps the default
 * — WebSocket invalidation drives freshness there, but the 30s fallback
 * matters for the brief window after reconnect.
 */
export const STALE_TIMES = {
  STATIC: 10 * 60_000,
  SLOW:    5 * 60_000,
} as const;
